import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-500">持续更新的技术干货</p>
          </div>
        </div>

        <div className="space-y-4">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-40 h-32 sm:h-24 rounded-lg overflow-hidden shrink-0">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {article.readCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-chat-3-line text-xs"></i>
                    </span>
                    {article.commentCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}